import { useCallback } from 'react';

import { cart } from 'core';
import { DeleteItem } from 'ui/components';

import type { CartDeleteItemProps } from './CartItems.d';

const CartDeleteItem = ({ onClose }: CartDeleteItemProps) => {
  const { deleteItem } = cart.commands.useCartCommand();
  const { data, isOpen: isOpenDeleteItem } = cart.hooks.useDeleteConfirmation();
  const { productCode, productPosition, productOrigin } = data;

  const handlerToggleDeleteItem = useCallback(() => {
    onClose(productCode);
  }, [productCode]);

  const handlerDeleteItem = useCallback(() => {
    onClose(productCode);

    deleteItem(productCode, productPosition, productOrigin);
  }, [productCode]);

  return (
    <>
      {isOpenDeleteItem && (
        <DeleteItem
          onClose={handlerToggleDeleteItem}
          onDelete={handlerDeleteItem}
          product={data}
          visible={isOpenDeleteItem}
        />
      )}
    </>
  );
};

export default CartDeleteItem;
